import React from 'react';
import classNames from 'classnames';
import Immutable from 'immutable';
import { Paragraph } from '@uncinc/react-drupal-core';

import {
  Container,
  Breadcrumbs,
} from '../../../components';

import './style.scss';

const NodeGuide = ({ entity, className }) => {
  const classes = classNames(className, 'Guide');

  if (!entity.getIn(['title', 0, 'value']) && !entity.getIn(['body', 0, 'processed'])) {
    return null;
  }

  return (
    <article typeof="schema:WebPage" className={classes}>
      <Container small>
        <Breadcrumbs includeCurrent />
        <div className="Guide">
          <h1 className="Guide__title">{entity.getIn(['title', 0, 'value'])}</h1>
        </div>
      </Container>
      <div className="Paragraphs">
        {
          entity.getIn(['field_paragraphs'], Immutable.List()).map((item, index) => {
            const paragraphId = item.get('target_id');
            const paragraph = item.getIn(['entity']);
            return (
              <Paragraph key={paragraphId} entity={paragraph} id={paragraphId} />
            );
          })
        }
      </div>
    </article>
  );
};

export default NodeGuide;
